import { memo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

/**
 * Legacy citation component for backward compatibility
 * Displays a simple citation with a link
 *
 * Memoized to prevent unnecessary re-renders
 *
 * @deprecated This component exists for backward compatibility with old citation format.
 * New messages should use ChatCitationsList instead.
 */
export const ChatLegacyCitation = memo(function ChatLegacyCitation({ citation }) {
  const { t } = useTranslation();

  if (!citation) {
    return null;
  }

  return (
    <div className="mt-4 pt-4 border-t border-border-default">
      <p className="text-xs text-muted">
        {t('chat.citation.source', 'Source')}:{' '}
        <a
          href={citation.url}
          target="_blank"
          rel="noopener noreferrer"
          className="text-brand no-underline hover:underline"
        >
          {citation.file}
        </a>
      </p>
    </div>
  );
});

ChatLegacyCitation.propTypes = {
  citation: PropTypes.shape({
    url: PropTypes.string,
    file: PropTypes.string,
  }),
};
